import ResponseSection from './ResponseSection';
import { ResponseSectionProps, ResponseSectionValueProps } from './types';

export type { ResponseSectionProps, ResponseSectionValueProps };
export default ResponseSection;
